import { createContext, useContext } from 'react';

export type UrlInt = string | undefined;

export const UrlContext = createContext<UrlInt>(undefined);

export const useUrl = () => {
  return useContext(UrlContext);
}